import { useCurrentLocale } from '@shared/hooks/intl';
import providers from './providers';

const useAuthentication = (provider: keyof ReturnType<typeof providers>) => {
  const locale = useCurrentLocale();
  const providersObject = providers(locale);
  const info = providersObject[provider];
  /* istanbul ignore if */
  if (!info.useProvider) {
    return { info, onSignIn: null, onClick: null };
  }

  return { info, ...info.useProvider() };
};

export default useAuthentication;
